import { useContext } from 'react';
import ReactSelect, { components } from 'react-select';
import { DefaultTheme, ThemeContext } from 'styled-components';

import { getOptionTypeByValue, getStylesFromTheme } from './helpers';
import { ISelect } from './interface';

import './Select.scss';
import { Icon } from '@conekta/frontino-ui/Icon';
import { ComponentSize } from '@conekta/frontino-ui/common/constants';
import { SelectLabel } from 'app/pages/frames/components/styled-components/SelectLabel';

const DropdownIndicator = (props: any) => (
  <components.DropdownIndicator {...props}>
    <Icon size={ComponentSize.SMALL}>keyboard_arrow_down</Icon>
  </components.DropdownIndicator>
);

const DEFAULT_SELECT_COMPONENTS: any = {
  IndicatorSeparator: () => null,
  DropdownIndicator,
};

export const Select = ({ disabled, input, labelOptions, options, onChange, tooltipHelper, ...rest }: ISelect) => {
  const THEME_CONTEXT: DefaultTheme = useContext(ThemeContext);
  const STYLES_FROM_THEME = getStylesFromTheme(THEME_CONTEXT);
  const { value, onChange: inputOnChange } = input;

  const handleOnChange = ({ value: inputValue }: any) => {
    inputOnChange(inputValue);
    onChange && onChange(inputValue);
  };
  const SelectContainer = ({ isDisabled, ...restContainer }: any) => (
    <>
      <SelectLabel className={`select-label-container ${isDisabled ? 'select-label-container__disabled' : ''}`}>
        <span className="select-label">{labelOptions.text}</span>
        {tooltipHelper}
      </SelectLabel>

      <components.SelectContainer {...restContainer}></components.SelectContainer>
    </>
  );

  return (
    <ReactSelect
      {...{
        input,
        options,
      }}
      {...rest}
      components={{ ...DEFAULT_SELECT_COMPONENTS, SelectContainer }}
      isDisabled={disabled}
      isSearchable={false}
      onChange={handleOnChange}
      styles={STYLES_FROM_THEME}
      value={getOptionTypeByValue(value, options)}
      filterOption={null}
    />
  );
};
